// Local-only fixtures for VITE_MOCK=true. Provides enough rows that the
// revision list overflows so we can verify scroll without backend access.
//
// The shape mirrors what the real /dvs/rest endpoints return BEFORE the
// parsers in helper.js process them — fetcher feeds the raw text through
// a parser. For the mock path we skip the parser and inject already-parsed
// shapes via the success callback directly.

export const mockFileStructure = {
  config: ['config'],
  experiments: ['experiment-1', 'experiment-2', 'experiment-3', 'experiment-4'],
  facet: ['facet-config'],
  forms: ['contact-form', 'lead-form'],
  itemlists: ['inventory-list', 'specials-list', 'service-list'],
  labels: ['header-labels', 'footer-labels'],
  metadata: ['seo-defaults', 'social-meta'],
  navigations: ['main-nav', 'footer-nav', 'mobile-nav'],
  pages: ['home', 'about', 'contact', 'inventory', 'service', 'parts', 'finance'],
  sitecontent: ['homepage-banner', 'about-content', 'contact-info'],
  slideshows: ['homepage-hero', 'specials-rotator'],
  'third-party': ['google-analytics', 'facebook-pixel', 'tagging'],
};

const dateBuckets = ['today', 'yesterday', 'thisWeek', 'lastWeek', 'thisMonth', 'lastMonth', 'thisYear', 'older'];
const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export function buildMockRevisions(count = 100) {
  const out = [];
  for (let i = 0; i < count; i += 1) {
    const bucket = dateBuckets[Math.min(Math.floor(i / 12), dateBuckets.length - 1)];
    const month = monthNames[i % 12];
    const date = (i % 28) + 1;
    const year = i < 50 ? 2026 : 2025;
    out.push({
      id: 1777000000000 + (count - i),
      date: {
        year,
        month,
        date,
        time: `${(i % 12) + 1}:${(i * 7) % 60}:${(i * 13) % 60} ${i % 2 === 0 ? 'am' : 'pm'}`,
        matches: bucket,
        daysOld: i * 2,
      },
      name: `Gopher | mock-change-${i + 1} | Site Automation Services`,
      source: i % 3 === 0 ? 'GOPHER' : i % 3 === 1 ? 'Composer' : 'DVS',
      message: `Mock revision ${i + 1} — Executed From Sassy Serverless`,
    });
  }
  return out;
}

export const mockSourceXml = `<?xml version="1.0" encoding="UTF-8"?>
<site id="mocksite">
  <homepage>INDEX</homepage>
  <properties>
${Array.from({ length: 50 }, (_, i) => `    <property name="prop${i}" value="value${i}" />`).join('\n')}
  </properties>
  <themekit>BLUE-WHITE</themekit>
  <franchises>
    <franchise>Acura</franchise>
    <franchise>Ford</franchise>
  </franchises>
  <variation-ref>v9_GLOBAL_0011_V2</variation-ref>
  <oem-profile-ref>landroverhobprofile</oem-profile-ref>
  <package-family>franchise</package-family>
  <account-id>mocksite</account-id>
  <sitemap>
${Array.from({ length: 80 }, (_, i) => `    <entry alias="ENTRY_${i}" id="v9_${i}" path="/path/${i}.htm" />`).join('\n')}
  </sitemap>
</site>`;

// Target XML with deliberate diffs vs source so DiffView shows red+green chunks.
export const mockTargetXml = mockSourceXml
  .replace('<homepage>INDEX</homepage>', '<homepage>NEW_INDEX</homepage>')
  .replace('landroverhobprofile', 'cadillacusprofile')
  .replace('<themekit>BLUE-WHITE</themekit>', '<themekit>GRAY-RED</themekit>');
